import {HttpClient} from '@angular/common/http';
import {Component, ViewChild, AfterViewInit, NgModule} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {merge, Observable, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import { BrowserModule } from '@angular/platform-browser';
import { HttpService } from '../http.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { MatSnackBar} from '@angular/material/snack-bar';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { ViewChildren } from '@angular/core'
import { QueryList } from '@angular/core'

import { EntradaCedoService } from '../_services'



/**
 * @title Table retrieving data through HTTP
 */
@Component({
  selector: 'app-cedos',
  templateUrl: './cedos.component.html',
  styleUrls: ['./cedos.component.scss']
})



export class CedosComponent implements AfterViewInit {
  displayedColumns: string[] = ['created', 'consignor_name', 'description', 'code', 
  'monto_base', 'iva', 'saldo_antes', 'variacion_saldo', 'saldo_despues', 
  'iva_antes', 'iva_despues'];
  cedunoDatabase: CedunoDatabase | null;
  data: CedunoIssue[] = [];

  entradaColumns: string[] = [ 'entrada_id', 'sku', 'product_name', 
    'pedimento', 'partida', 'cantidad', 'costo_unitario', 
    'parcial', 'total', 'created'];
  entradaDatabase: EntradaDatabase | null;
  data_entrada: EntradaIssue[] = [];

  // TABLA SALIDAS
  salidaColumns: string[] = [ 'created_at', 'consignor_name', 'canal', 
    'platform_name', 'sku', 'product_name', 'cantidad', 
    'dias_transcurridos'];
  salidaDatabase: SalidaDatabase | null;
  data_salida: SalidaIssue[] = [];



  // TABLA INVENTARIOS
  inventarioColumns: string[] = [ 'fecha_corte', 'consignor_name', 'sku', 'product_name', 
    'pedimento', 'cantidad'];
  inventarioDatabase: InventarioDatabase | null;
  data_inventario: InventarioIssue[] = [];



  coins;





  la_fecha_corte;
  entradaForm: FormGroup;
  form_ceduno: []
  entrada_cedos: any = {};


  resultsLength = 0;
  resultsLengthInventario = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  //@ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  @ViewChildren(MatPaginator) paginator:  QueryList<MatPaginator>;

  

  constructor(
          private formBuilder: FormBuilder,
          private entrada_cedosService: EntradaCedoService,
          private _httpClient: HttpClient, 
          private _hs: HttpService,
          private snackBar: MatSnackBar,
    ) { }


  ngOnInit() {
    this.entradaForm = this.formBuilder.group({
      cedo_id: ['', Validators.required],
      marketful_id: ['', Validators.required],
      sku: ['', Validators.required],
      pedimento: ['', Validators.required],
      partida: ['', Validators.required],
      cantidad: ['', Validators.required],
      unidad: ['', Validators.required],
      costo_unitario: ['', Validators.required],
      fecha_recibido: ['', Validators.required],
    });

  }

  onSubmitRE() {
    console.log("submitted el form entrada cedos")
    this.entrada_cedos["cedo_id"] = this.entradaForm.value.cedo_id
    this.entrada_cedos["marketful_id"] = this.entradaForm.value.marketful_id
    this.entrada_cedos["sku"] = this.entradaForm.value.sku
    this.entrada_cedos["pedimento"] = this.entradaForm.value.pedimento
    this.entrada_cedos["partida"] = this.entradaForm.value.partida
    this.entrada_cedos["cantidad"] = this.entradaForm.value.cantidad
    this.entrada_cedos["unidad"] = this.entradaForm.value.unidad
    this.entrada_cedos["costo_unitario"] = this.entradaForm.value.costo_unitario
    this.entrada_cedos["fecha_recibido"] = this.entradaForm.value.fecha_recibido

    console.log(this.entrada_cedos)
     this.entrada_cedosService.registrar(this.entrada_cedos)
            .pipe(first())
            .subscribe(
                data => {
                   //  this.router.navigate([this.returnUrl]);
                   console.log("guardado recibido en component")
                   console.log("la data es")
                   console.log(data)
                   //this.openSnackBar("Compra guardada", "OK")
                   this.snackBar.open("Entrada Cedos guardada", "OK", {                      
                      duration: 2000,
                    });
                   
                },
                error => {
                  //  this.error = error;
                    // this.loading = false;
                    console.log("error recibido en component")
                });
  }



  ngAfterViewInit() {

    console.log("el paginador ngavi es " +  this.paginator.toArray()[1].pageIndex)

    this.cedunoDatabase = new CedunoDatabase(this._httpClient);
    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.first.pageIndex = 0);
    merge(this.sort.sortChange, this.paginator.first.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.cedunoDatabase!.getRepoIssues(
            this.sort.active, this.sort.direction, this.paginator.first.pageIndex);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;
          console.log("vamos en la 72")
          console.log(data)

          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  
    // TABLA ENTRADAS
    this.entradaDatabase = new EntradaDatabase(this._httpClient);
    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.last.pageIndex = 0);
    merge(this.sort.sortChange, this.paginator.last.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.entradaDatabase!.getRepoEntradaIssues(
            this.sort.active, this.sort.direction, this.paginator.last.pageIndex);
        }),
        map(data_entrada => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data_entrada.total_count;

          console.log(data_entrada)

          return data_entrada.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data_entrada.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data_entrada => this.data_entrada = data_entrada);

    // TABLA SALIDAS
    this.salidaDatabase = new SalidaDatabase(this._httpClient);
    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.toArray()[2].pageIndex = 0);
    merge(this.sort.sortChange, this.paginator.toArray()[2].page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.salidaDatabase!.getRepoSalidaIssues(
            this.sort.active, this.sort.direction, this.paginator.toArray()[2].pageIndex);
        }),
        map(data_salida => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data_salida.total_count;

          console.log(data_salida)

          return data_salida.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data_salida.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data_salida => this.data_salida = data_salida);




      // TABLA INVENTARIO
    this.inventarioDatabase = new InventarioDatabase(this._httpClient);
    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.last.pageIndex = 0);
    merge(this.sort.sortChange, this.paginator.last.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.inventarioDatabase!.getRepoInventarioIssues(
            this.sort.active, this.sort.direction, this.paginator.last.pageIndex);
        }),
        map(data_inventario => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLengthInventario = data_inventario.total_count;

          console.log(data_inventario)

          return data_inventario.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data_inventario.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data_inventario => this.data_inventario = data_inventario);

  }

  setClasses(fecha_creado) {
    let hoy = new Date();
    let fecha_pago = new Date(fecha_creado);

    let fecha_corte = new Date(this.coins);


   
    let myClasses = {
     // retrasado: Date.parse(fecha_corte.toISOString()) > Date.parse(fecha_creado),
     // a_tiempo: Date.parse(fecha_corte.toISOString()) < Date.parse(fecha_creado),
    }

    return  myClasses
  }




}



export interface CedunoApi {
  items: CedunoIssue[];
  total_count: number;
}

export interface CedunoIssue {
  created_at: string;
  number: string;
  state: string;
  title: string;
}

/** An example database that the data source uses to retrieve data for the table. */
export class CedunoDatabase {
  constructor(private _httpClient: HttpClient) {}

  getRepoIssues(sort: string, order: string, page: number): Observable<CedunoApi> {
    console.log(sort)
    console.log(order)
    console.log(page)
    const href = 'https://vertigofin.herokuapp.com/query_cedunos.json' + page;
    // const href = 'http://localhost:3000/query_sales.json' + page;
    const requestUrl =
        `${href}?sort=${sort}&order=${order}&page=${page + 1}`;

    return this._httpClient.get<CedunoApi>(requestUrl);
  }
}



export interface EntradaApi {
  items: EntradaIssue[];
  total_count: number;
}

export interface EntradaIssue {
  created_at: string;
  number: string;
  state: string;
  title: string;
}

/** An example database that the data source uses to retrieve data for the table. */
export class EntradaDatabase {
  constructor(private _httpClient: HttpClient) {}


  getRepoEntradaIssues(sort: string, order: string, page: number): Observable<EntradaApi> {
    console.log(sort)
    console.log(order)
    console.log(page)
    const href = 'https://vertigofin.herokuapp.com/query_cedos_entradas.json' + page;
    // const href = 'http://localhost:3000/query_sales.json' + page;
    const requestUrl =
        `${href}?sort=${sort}&order=${order}&page=${page + 1}`;

    return this._httpClient.get<EntradaApi>(requestUrl);
  }
}



// TABLA SALIDAS 
export interface SalidaApi {
  items: SalidaIssue[];
  total_count: number;
}

export interface SalidaIssue {
  created_at: string;
  number: string;
  state: string;
  title: string;
}

/** An example database that the data source uses to retrieve data for the table. */
export class SalidaDatabase {
  constructor(private _httpClient: HttpClient) {}


  getRepoSalidaIssues(sort: string, order: string, page: number): Observable<SalidaApi> {
    console.log(sort)
    console.log(order)
    console.log(page)
    const href = 'https://vertigofin.herokuapp.com/query_cedos_salidas.json' + page;
    // const href = 'http://localhost:3000/query_sales.json' + page;
    const requestUrl =
        `${href}?sort=${sort}&order=${order}&page=${page + 1}`;

    return this._httpClient.get<SalidaApi>(requestUrl);
  }
}




// TABLA INVENTARIO 
export interface InventarioApi {
  items: InventarioIssue[];
  total_count: number;
}

export interface InventarioIssue {
  created_at: string;
  number: string;
  state: string;
  title: string;
}

/** An example database that the data source uses to retrieve data for the table. */
export class InventarioDatabase {
  constructor(private _httpClient: HttpClient) {}


  getRepoInventarioIssues(sort: string, order: string, page: number): Observable<InventarioApi> {
    console.log(sort)
    console.log(order)
    console.log(page)
    const href = 'https://vertigofin.herokuapp.com/query_cedos_inventarios.json' + page;
    // const href = 'http://localhost:3000/query_sales.json' + page;
    const requestUrl =
        `${href}?sort=${sort}&order=${order}&page=${page + 1}`;

    return this._httpClient.get<InventarioApi>(requestUrl);
  }
}